import React from "react";
import { MESSAGE_THEME_OPTIONS } from "../../utils/messages/conversationThemes";

export default function ConversationThemeSection({ themeKey, onSelectTheme, disabled }) {
  return (
    <div>
      <h3 className="text-[13px] font-semibold text-white/90 mb-3">Theme</h3>
      <p className="text-[12px] text-white/45 mb-3">
        Everyone in this chat sees the same background accent once you save a theme.
      </p>
      <div className="grid grid-cols-2 gap-2">
        {MESSAGE_THEME_OPTIONS.map((opt) => (
          <button
            key={opt.id}
            type="button"
            disabled={disabled}
            onClick={() => onSelectTheme(opt.id)}
            className={[
              "rounded-xl border px-3 py-2.5 text-left transition text-[12px]",
              themeKey === opt.id
                ? "border-white/35 bg-white/[0.08] text-white"
                : "border-white/10 bg-white/[0.03] text-white/80 hover:bg-white/[0.06]",
              disabled ? "opacity-50 cursor-not-allowed" : "",
            ].join(" ")}
          >
            <div className="font-medium">{opt.label}</div>
            <div className="text-white/45 text-[11px] mt-0.5">{opt.description}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
